module.exports = {"TXTCLI_Show_More_Options":{"id":"TXTCLI_Show_More_Options","defaultMessage":"顯示較多選項"}}